<!--
 * @Author: zyy
 * @Date: 2023-09-06 11:35:47
 * @LastEditTime: 2023-10-25 17:23:19
 * @FilePath: /tjzhsq-admin/src/views/platform/vip/level/edit.vue
 * @Description: yahu~
 * 
-->
<template>
    <a-modal :title="title" v-model="show" @ok="confirmModal" destroy-on-close width="60%" centered>
        <a-form-model ref="formRef" :model="formData" :rules="rules" style="width: 600px;">
            <a-form-model-item label="等级名称" prop="name">
                <a-input v-model="formData.name" placeholder="请输入等级名称" allow-clear></a-input>
            </a-form-model-item>
            <a-form-model-item label="最低成长值" prop="min_points">
                <a-input v-model="formData.min_points" placeholder="请输入最低成长值" allow-clear></a-input>
            </a-form-model-item>
            <a-form-model-item label="图片" prop="image_url">
                <a-upload name="media" :show-upload-list="false" list-type="picture-card" :action="$uploadUrl"
                    class="app-avatar-uploader" :before-upload="$beforeUpload" @change="handleChange">
                    <dy-image :src="formData.image_url" v-if="formData.image_url" preview></dy-image>
                    <a-icon :type="image.loading ? 'loading' : 'plus'" v-else></a-icon>
                </a-upload>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>

<script >
import { setFormData } from '@/plugins/utils.js'
import GradeService from '@/io/vip/grade.js'

export default {
    name: 'LevelEdit',
    emits: ['close', 'submit'],
    data() {
        return {
            title: '新增',
            show: false,
            loading: false,
            formData: {
                id: undefined,
                name: undefined,
                min_points: undefined,
                image_url: undefined
            },
            image: {
                loading: false,
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请输入等级名称'
                    }
                ],
                min_points: [
                    {
                        required: true,
                        message: '请输入最低成长值'
                    }
                ],
                image_url: [
                    {
                        required: true,
                        message: '请选择图片'
                    }
                ]
            }
        }
    },
    methods: {
        handleChange(info) {
            let status = info.file.status;
            if (status) {
                if (status === 'done') {
                    this.image.loading = false;
                    this.formData.image_url = info.file.response.media;
                } else {
                    this.image.loading = true;
                }
            }
        },
        open(data) {
            this.title = data ? '编辑' : '新增'
            this.show = true
            if (data) setFormData(data, this.formData)
        },
        close() {
            this.show = false
            this.$emit('close')
        },
        confirmModal() {
            this.$refs.formRef.validate(async valid => {
                if (valid) this.formData.id ? await GradeService.edit(this.formData) : await GradeService.add(this.formData)
                this.$message.success(`${this.formData.id ? '编辑' : '新增'}成功`)

                this.$emit('submit')
                this.close()
            })



        }
    }
}

</script>


